var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73314 0.237062C9.77067 -0.0790205 10.2293 -0.0790205 10.2669 0.237062L10.5815 2.8887C10.9878 6.31269 13.6873 9.01224 17.1113 9.41851L19.7629 9.73314C20.079 9.77067 20.079 10.2293 19.7629 10.2669L17.1113 10.5815C13.6873 10.9878 10.9878 13.6873 10.5815 17.1113L10.2669 19.7629C10.2293 20.079 9.77067 20.079 9.73314 19.7629L9.41851 17.1113C9.01224 13.6873 6.31269 10.9878 2.8887 10.5815L0.237062 10.2669C-0.0790205 10.2293 -0.0790205 9.77067 0.237062 9.73314L2.8887 9.41851C6.31269 9.01224 9.01224 6.31269 9.41851 2.8887L9.73314 0.237062Z",
    fill: "#F2994A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftStar);
export default __webpack_public_path__ + "static/media/soft_star.d705cc55de44d5ffa1771ce9eda64507.svg";
export { ForwardRef as ReactComponent };